import { ScrollTrigger } from "gsap/ScrollTrigger";

const PostsList = () => {
	const block = document.querySelectorAll(".posts-list");
	if (!block) {
		return;
	}
	const scrollTriggerRefresh = () => {
		setTimeout(() => {
			ScrollTrigger.refresh();
		}, 200);
	};

	block.forEach((el) => {
		const items = el.querySelectorAll(".posts-list__list-item");
		const footer = el.querySelector(".posts-list__footer");
		const moreControl = el.querySelector(".posts-list__footer .custom-link");
		const itemsCount = 5;
		let itemsToShow = itemsCount;

		moreControl.addEventListener("click", (e) => {
			itemsToShow = itemsToShow + itemsCount;

			items.forEach((item, index) => {
				if (index < itemsToShow && !item.classList.contains("active")) {
					item.classList.add("active");
				}
			});

			if (itemsToShow >= items.length) {
				footer.classList.add("posts-list__footer_hide")
			}

			scrollTriggerRefresh();
		});
	});
};

export default PostsList;
